import { useAlert, useLanguage, Utils } from '@infominds/react-native-components'
import { useAuthentication } from '@infominds/react-native-license'
import { useNavigation } from '@react-navigation/native'
import mime from 'mime'
import React, { useEffect, useState } from 'react'
import { Dimensions, StyleSheet, View } from 'react-native'
import ImageZoom from 'react-native-image-pan-zoom'

import { File } from '../../types'

export function PdfViewer(props: { load: () => Promise<File | null> }) {
  const { i18n } = useLanguage()
  const { erp } = useAuthentication()
  const { alert } = useAlert()
  const navigation = useNavigation()

  const [source, setSource] = useState<string | undefined>(undefined)
  const [type, setType] = useState<string | undefined>(undefined)

  useEffect(() => {
    props
      .load()
      .then(res => {
        if (res === null || res.stream === '') {
          alert(i18n.t('MISSING_INVOICE'), i18n.t('MISSING_INVOICE_DESCRIPTION'), [
            { isPreferred: true, onPress: () => navigation.goBack(), style: 'default', text: 'OK' },
          ])
          return
        }

        res.docType = res.docType.toLowerCase()

        setType(res.docType)

        const docMime = mime.getType(res.docType)

        if (docMime?.includes('pdf')) {
          setSource(res.stream)
        } else if (docMime?.includes('image')) {
          setSource('data:image/' + res.docType + ';base64,' + res.stream)
        } else if (erp === 'Radix' && docMime?.includes('xml')) {
          alert(i18n.t('ERROR'), i18n.t('WRONG_XML_FORMAT_DESCRIPTION'), [
            { isPreferred: true, onPress: () => navigation.goBack(), style: 'default', text: 'OK' },
          ])
        } else if (erp === 'Radix' && docMime?.includes('pkcs7')) {
          alert(i18n.t('ERROR'), i18n.t('WRONG_P7M_FORMAT_DESCRIPTION'), [
            { isPreferred: true, onPress: () => navigation.goBack(), style: 'default', text: 'OK' },
          ])
        } else {
          alert(i18n.t('FORMAT_NOT_MANAGED'), Utils.stringValueReplacer(i18n.t('FORMAT_NOT_MANAGED_DESC'), res.docType), [
            { isPreferred: true, onPress: () => navigation.goBack(), style: 'default', text: 'OK' },
          ])
        }
      })
      .catch(console.error)
  }, [])

  if (type === 'pdf' && source) {
    return (
      <View style={styles.containerTest}>
        <iframe src={`data:application/pdf;base64,${source}`} height="100%" width="100%" />
      </View>
    )
  } else if (source) {
    return (
      <View style={styles.containerTest}>
        {/* @ts-ignore ok! */}
        <ImageZoom
          cropWidth={Dimensions.get('window').width}
          cropHeight={Dimensions.get('window').height}
          imageWidth={Dimensions.get('window').width}
          imageHeight={Dimensions.get('window').height}>
          <View style={styles.container}>
            {/* eslint-disable-next-line react-native/no-inline-styles */}
            <img draggable={false} style={{ objectFit: 'scale-down' }} src={source} />
          </View>
        </ImageZoom>
      </View>
    )
  } else {
    return <></>
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
  },
  containerTest: {
    flex: 1,
    height: '100%',
    width: '100%',
  },
})
